export default __webpack_public_path__ + "static/desk07-4e1b9564aa64bd6e121ccf76b62f3246.png";